import { Component, Input } from '@angular/core';
import { FilterReference, FilterService } from './filter.service';

@Component({
  selector: 'filter-slider',
  templateUrl: '../templates/filter-slider.component.html',
  styleUrls: ['../styles/components/filter-slider.component.less']
})
export class FilterSliderComponent {
  @Input('modifier') modifier: string;
  @Input('collection') collection: string;

  constructor(public filterService: FilterService) {}

  showItem(item: FilterReference): boolean {
    return typeof item.active === 'boolean' && !item.active;
  }
}
